module.exports = __webpack_public_path__ + "static/seabour-logo-8f784e8409defa0db6c62bfe13029f07.png";